import selectors from '../selectors';
import actionTypes from '../constants/action-types';
import siteLocales from '../../site-locales';
import blocks from '../../blocks';
import site from '../index';
import view from '../../view';

const pageSettings = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PAGE_SETTINGS: {
      const {
        pageId,
        settings: { htmlLocale },
      } = action.payload;
      const state = store.getState();
      const page = selectors.getPage(state, pageId);
      const activePageId = site.selectors.getActivePageId(state);
      const activePage = site.selectors.getPage(state, activePageId);
      const activePageHtmlLocale = activePage && activePage.htmlLocale;
      const activePageLocale = activePage && activePage.locale;
      const siteBlocks = blocks.selectors.getBlocks(state);

      if (htmlLocale !== activePageHtmlLocale && page.id === activePageId) {
        // we are using `htmlLocale` to localize blocks, most of the time `locale` and `htmlLocale` would be same,
        // but this covers edge case for older users who had changed `htmlLocale` before multilingual site introduction and they have their block localized to that language
        store.dispatch(siteLocales.actions.clearBlocksHtml());
        store.dispatch(siteLocales.actions.clearPageTemplatesHtml());
        siteBlocks.forEach((block) => {
          store.dispatch(blocks.actions.initializeBlock(block.id, activePageLocale, htmlLocale));
        });
      }

      const { settings } = action.payload;

      const isNavigationItemTextChanged =
        settings.displayInNavigation && state.name !== settings.name;
      const isNavigationItemLinkChanged =
        settings.displayInNavigation && page.path !== settings.path;
      const isCurrentPageAffected = page.id === activePageId;
      const isNavigationDisplayChanged = page.displayInNavigation !== settings.displayInNavigation;

      next(action);

      if (
        isCurrentPageAffected ||
        isNavigationItemTextChanged ||
        isNavigationItemLinkChanged ||
        isNavigationDisplayChanged
      ) {
        store.dispatch(view.actions.forceReloadView());
      }

      break;
    }
    default:
      next(action);
  }
};

export default pageSettings;
